import { Component, OnInit, ViewChild, Input, OnDestroy } from "@angular/core";
import { Platform } from "@ionic/angular";
import { take, filter } from 'rxjs/operators';
import { GeoResponse } from "src/app/interfaces/geo-interface";
import { CustomerModel } from "src/app/models/customer-model";
import { AuthenticationService } from "src/app/services/authentication/authentication.service";
import { BannerService } from "src/app/services/banner/banner.service";
import { isUndefined } from "src/app/services/codeUtils";
import { ConfigService } from "src/app/services/config/config.service";
import { EventsService } from "src/app/services/event/event.service";
import { JurisdictionService } from "src/app/services/geo/jurisdiction.service";
import { LobbyStateService } from "src/app/services/lobbyState/lobby-state.service";
import { MenuStateService } from "src/app/services/menu-state/menu-state.service";
import { TimeService } from "src/app/services/time-service/time.service";
import { UserSessionService } from "src/app/services/user-session/user-session.service";
import { Navigator } from "../menu/navigator";
import { Router } from "@angular/router";
import { BiometricService } from "src/app/services/biometric/biometric.service";
import { LocationWarningService } from "src/app/services/location-warning/location-warning.service";

@Component({
  selector: "app-site-header",
  templateUrl: "./site-header.component.html",
  styleUrls: ["./site-header.component.scss"],
})

export class SiteHeaderComponent implements OnInit, OnDestroy {
  @ViewChild("mainMenuPopover") mainMenuPopover;
  @ViewChild("secondaryMenuPopover") secondaryMenuPopover;
  @Input() tab: String;

  public isLiveDealer = false;
  public isWebView = false;
  public isMobileApp = false;
  public isAuthenticated: boolean = false;
  public isOpenMainPopover = false;
  public isOpenSecondaryPopover = false;
  public displayRGLogo: boolean;
  public displayStateSwitcher: boolean;
  public showDevelopButton: boolean = false;
  public hideBoydRewards: boolean = false;

  constructor(
    public authenticationService: AuthenticationService,
    public bannerService: BannerService,
    public config: ConfigService,
    public events: EventsService,
    public jurisdiction: JurisdictionService,
    public navigator: Navigator,
    public userSessionService: UserSessionService,
    public router: Router,
    public biometric: BiometricService,
    public lobbyStateService: LobbyStateService,
    private eventsService: EventsService,
    private menuStateService: MenuStateService,
    private locationWarningService: LocationWarningService,
    private platform: Platform
  ) { }

  ngOnInit() {
    this.verifyAuth();
    this.checkSession();
    if (this.config.getConfig().BOYD_REWARDS_HIDE === '1') {
      this.hideBoydRewards = true;
    }
    this.events.subscribe("event:login", () => {
      this.verifyAuth();
    });

    this.isMobileApp = this.platform.is("capacitor");

    this.router.events.subscribe(() => {
      if (this.isMobileApp) {
        this.checkRoutes(this.router.url)

      }
    });
    this.eventsService.subscribe("action:changeTab", (tabName) => {
      this.navigator.toTab(tabName, true);
      this.verifyAuth();
    });

    this.eventsService.subscribe("event:authentication:logout", () => {
      this.verifyAuth();
    });

    this.eventsService.subscribe("event:signupResult:flag", () => {
      this.verifyAuth();
    });

    this.menuStateService.menuStateObservable.subscribe((isOpen) => {
      this.isOpenMainPopover = isOpen;
    });

    this.eventsService.subscribe("event:config:reload", () => {
      console.log("config reloaded!", this.config.getClientApp());
    });

    this.eventsService.subscribe("event:tabs:load", (tab, data?) => {
      if (isUndefined(data)) data = false;
      this.navigator.toTab(tab, data);
    });

    this.displayRGLogo = this.config.getConfig().FEATURE_SHOW_RG_LOGO === '1' ? true : false;
    this.displayStateSwitcher = this.config.getConfig().FEATURE_SHOW_STATE_SWITCH_SELECTOR === '1' ? true : false;

  }

  joinNow() {
    let onJoin = this.config.getConfig().FEATURE_LOCATION_WARNING_ON_JOIN === "1" ? true : false;
    if (onJoin) {
      if (this.locationWarningService.locationIsAllowed()) {
        this.navigateTo('SignupOptionsComponent', '', { connectBoydCardPath: false });
      } else {
        this.navigateTo('SignupStepOneComponent','',{connectBoydCardPath:false});
        this.locationWarningService.openLocationWarning('join', { connectBoydCardPath: false });
      }
    } else {
      this.navigateTo('SignupOptionsComponent', '', { connectBoydCardPath: false });
    }
  }

  joinNowNoBoyd() {
    let onJoin = this.config.getConfig().FEATURE_LOCATION_WARNING_ON_JOIN === "1" ? true : false;
    if (onJoin) {
      if (this.locationWarningService.locationIsAllowed()) {
        this.navigateTo('SignupStepOneComponent', '', { connectBoydCardPath: false });
      } else {
        this.navigateTo('SignupStepOneComponent','',{connectBoydCardPath:false});
        this.locationWarningService.openLocationWarning('join', { connectBoydCardPath: false });
      }
    } else {
      this.navigateTo('SignupStepOneComponent', '', { connectBoydCardPath: false });
    }
  }


  verifyAuth() {
    this.userSessionService.isAuthenticated().then((isAuthenticated) => {
      this.isAuthenticated = isAuthenticated;
      //this.eventsService.publish('menuopen');
    });
  }

  checkRoutes(url) {
    const routes = {
      '/livedealer': 'isLiveDealer',
      '/c': 'isWebView',
    };

    for (const key in routes) {
      this[routes[key]] = false;
    }
    if (routes[url]) {
      this[routes[url]] = true;
    }
  }

  public navigateTo(page: string, options?, params?) {
    return this.navigator.navigateTo(page, options, params);
  }

  public initGeo() {
    this.jurisdiction
      .debounceVerifyJurisdiction(() => this.geoConsole())
      .then((geoResp: GeoResponse) => { })
      .catch((err: any) => { });
  }

  public geoConsole() {
    console.log("Geo is Running");
  }

  public presentPopover(e: Event) {
    this.mainMenuPopover.event = e;
    this.isOpenMainPopover = true;
  }

  public onLogoClick() {
    return this.navigator.toCasino();
  }

  public presentPopoverSecondary(e: Event) {
    this.secondaryMenuPopover.event = e;
    this.isOpenSecondaryPopover = true;
  }

  public mainPopoverDidDmismiss() {
    this.isOpenMainPopover = false;
  }

  public secondaryPopoverDidDmismiss() {
    this.isOpenSecondaryPopover = false;
  }

  public checkSession() {
    const userStatus = { sessionToken: "", customerId: 12 };
    if (!!this.canCallTheService("checkSession")) {
      this.authenticationService.checkSession().then((sessionResult) => {
        if (!!sessionResult.subject) {
          sessionResult.subject.subscribe(
            (response) => {
              if (!isUndefined(response.result) && !!response.result) {
                this.userSessionService.setSessionToken(
                  sessionResult.sessionToken
                );
                userStatus.sessionToken = sessionResult.sessionToken;
              }
              this.userSessionService
                .refreshCustomer()
                .subscribe((customer: CustomerModel) => {
                  userStatus.customerId = customer.customerId;
                  this.bannerService.fetchAllBanners();
                  this.events.publish("event:appInit:init", {
                    triggeredBy: "REFRESH",
                  });
                  this.userSessionService.setUserStatus(userStatus);
                });
            },
            (error) => {
              if (
                error &&
                "error_code" in error &&
                error.error_code == "hasExceededDepositLimit"
              ) {
                this.userSessionService.clear();
              }
            }
          );
          return;
        }
        return this.userSessionService.clear();
      });
    }
  }

  async handleLogin() {
    if (this.platform.is('capacitor')) {
      const loginSucess = await this.biometric.biometricLoginInitiator();
      if (!loginSucess) this.navigator.navigateTo('LoginComponent', "", { biometricVerificationFailed: true });
    } else {
      this.navigateTo('LoginComponent')
    }
  }

  canCallTheService(funcName) {
    let isAllowed = true;
    switch (funcName) {
      case "checkSession":
        let hash = document.location.hash;
        if (hash !== "" && (hash == "#show-page" || ~hash.indexOf("#paypal") || ~hash.indexOf("#interac-return"))) {
          isAllowed = false;
        }
        break;
    }
    return isAllowed;
  }

  protected developAction() {
  }
  ngOnDestroy() {
    // if (this.intervalId) clearInterval(this.intervalId);
  }
}
